import React from 'react';
import { Button } from 'ui-component-library/components';
import { string, bool, func } from 'prop-types';

import {
  StyledModal,
  EmailContent,
  ErrorMessage,
  ButtonWrapper,
  TextAreaContainer,
  EmailContentLabel,
} from './email-modal-error.style';

/**
 * Email Error Modal Component
 * @param {object} params - object containing props
 * @param {bool} showModal - boolean var to show modal or not
 * @param {func} closeModal - function to close modal
 * @param {string} title - title of modal
 * @param {string} errorMessage - error message
 * @param {string} content - content for modal
 * @param {string} cancelButtonLabel - label for closing modal button
 * @param {string} submitButtonLabel - label for submit modal button
 * @param {func} onEmailSubmit - function for handling submit button
 * @param {bool} emailFailed - flag for displaying different content if the email failed
 * @param {number} height - Height of email error modal
 * @return {element}
 */
const EmailErrorModal = ({
  showModal,
  closeModal,
  title,
  errorMessage,
  content,
  cancelButtonLabel,
  submitButtonLabel,
  onEmailSubmit,
  emailFailed,
  height,
}) => (
  <StyledModal
    title={title}
    isOpen={showModal}
    width="480px"
    onModalClose={closeModal}
  >
    <ErrorMessage>{errorMessage}</ErrorMessage>
    <TextAreaContainer>
      <EmailContentLabel>Load Information</EmailContentLabel>
      <EmailContent height={height}>
        {content}
      </EmailContent>
    </TextAreaContainer>
    <ButtonWrapper>
      <Button
        text={cancelButtonLabel}
        isSecondary={!emailFailed}
        size="large"
        onClick={closeModal}
      />
      {!emailFailed && (
        <Button
          text={submitButtonLabel}
          size="large"
          isDisabled={false}
          onClick={onEmailSubmit}
        />
      )}
    </ButtonWrapper>
  </StyledModal>
);
EmailErrorModal.propTypes = {
  showModal: bool,
  closeModal: func,
  title: string,
  errorMessage: string,
  content: string,
  cancelButtonLabel: string,
  submitButtonLabel: string,
  onEmailSubmit: func,
  emailFailed: bool,
  height: string,
};

EmailErrorModal.defaultProps = {
  showModal: false,
  closeModal: func,
  title: '',
  errorMessage: '',
  content: '',
  cancelButtonLabel: 'Cancel',
  submitButtonLabel: 'Submit',
  onEmailSubmit: () => {},
  emailFailed: false,
  height: '400px',
};

export default EmailErrorModal;
